const manageSchedule = {
  manageSchedule: {
    pageTitle: '전체 스케줄 관리',
    description: '등록된 모든 스케줄을 확인하고 관리합니다.',
    tabs: {
      reservedSchedule: '예약된 스케줄',
      duplicateBuffer: '중복 버퍼 설정'
    },
    filters: {
      groundStation: '지상국',
      dateRange: '기간',
      search: '검색'
    },
    buttons: {
      search: '검색',
      reset: '초기화',
      cancel: '취소',
      close: '닫기',
      delete: '삭제',
      create: '생성',
      update: '수정'
    },
    buffer: {
      title: '중복 버퍼 설정',
      scheduled: '예약 시간',
      label: '중복 버퍼 (분)',
      tooltip: '예약 사이 최소 간격(분)으로, 설정한 값만큼 앞뒤로 여유 시간을 둡니다.',
      placeholder: '예: 5',
      loading: '불러오는 중...',
      currentBuffer: '현재 버퍼',
      minutesUnit: '분',
      updatedAt: '업데이트 시간: {{time}}',
      noBuffer: '현재 설정된 버퍼가 없습니다.',
    },
    modals: {
      deleteBufferTitle: '버퍼 삭제',
      deleteBufferBody: '버퍼 설정을 삭제하시겠습니까?\n이 작업은 되돌릴 수 없습니다.',
      cancelScheduleTitle: '스케줄 취소',
      cancelScheduleBody: '스케줄을 정말로 취소하시겠습니까?\n이 작업은 되돌릴 수 없습니다.'
    },
    alerts: {
      statusUpdateFailed: '상태 변경에 실패했습니다. 다시 시도해주세요.',
      cannotCancel: '취소할 수 없는 스케줄입니다.',
      cancelFailed: '취소에 실패했습니다. 다시 시도해주세요.',
      bufferRequired: 'Buffer minutes 값을 입력해주세요.',
      bufferPositive: '0 이상으로 입력해주세요.',
      noOrderId: 'orderId가 없습니다. 다시 시도해주세요.'
    }
  }
};

export default manageSchedule;